import React from "react";
import { useTranslation } from "react-i18next";
import powersCircle1 from "../../img/experience/powers-circle1.webp";
import powersCircle2 from "../../img/experience/powers-circle2.webp";

function SmallCard({ titleKey, descKey }) {
  const { t } = useTranslation();
  return (
    <div className="bg-white border border-[#e5e5e5] rounded-[20px] p-[30px] xl:p-[30px] flex flex-col justify-between min-h-[133px] xl:min-h-[255px] flex-1">
      <div className="w-[10px] h-[10px] xl:w-[14px] xl:h-[14px] rounded-[3px] xl:rounded-[7px] bg-[#cacaca]" />
      <div className="flex flex-col gap-[8px] xl:gap-[12px] mt-[10px] xl:mt-0">
        <p className="font-['Montserrat'] font-extrabold text-[16px] xl:text-[20px] text-[#020202] leading-normal">
          {t(titleKey)}
        </p>
        <p className="font-['Inter'] font-normal text-[14px] xl:text-[16px] text-[#818181] leading-[1.4]">
          {t(descKey)}
        </p>
      </div>
    </div>
  );
}

function BigCard({ t }) {
  return (
    <div className="relative rounded-[20px] overflow-hidden bg-[#fcefea] p-[20px_28px_20px_30px] xl:p-[30px_28px_51px_60px] flex flex-col justify-between min-h-[259px] xl:min-h-[528px] xl:w-[600px] xl:shrink-0">
      {/* Decorative circle images from Figma */}
      <div className="pointer-events-none absolute inset-0 rounded-[20px] overflow-hidden">
        <img
          src={powersCircle1}
          alt=""
          aria-hidden
          className="absolute max-w-none"
          style={{ height: "153.25%", left: "-7.87%", top: "-39.23%", width: "107.87%" }}
        />
      </div>
      <div className="pointer-events-none absolute inset-0 rounded-[20px] overflow-hidden">
        <img
          src={powersCircle2}
          alt=""
          aria-hidden
          className="absolute max-w-none"
          style={{ height: "141.99%", left: "0%", top: "-39.99%", width: "100%" }}
        />
      </div>
      <div className="w-[10px] h-[10px] xl:w-[14px] xl:h-[14px] rounded-[7px] bg-[#f04e0a] relative" />
      <div className="flex flex-col gap-[8px] xl:gap-[12px] relative">
        <p className="font-['Montserrat'] font-extrabold text-[20px] xl:text-[36px] text-white leading-normal">
          {t("exp.powers.c4.title")}
        </p>
        <p className="font-['Inter'] font-normal text-[14px] xl:text-[16px] text-[#b9b9b9] leading-[1.4] xl:max-w-[442px]">
          {t("exp.powers.c4.desc")}
        </p>
      </div>
    </div>
  );
}

function Powers() {
  const { t } = useTranslation();

  return (
    <section className="mt">
      <div className="glcontainer flex flex-col gap-[40px]">
        <h2 className="font-['Montserrat'] font-black text-[24px] xl:text-[46px] text-[#0a0a0a] tracking-[-0.92px] uppercase leading-none xl:max-w-[636px]">
          {t("exp.powers.title")}
        </h2>

        {/* Desktop: left col (2+1 cards) + right big card */}
        <div className="hidden xl:flex gap-[20px]">
          <div className="flex flex-col gap-[20px] w-[600px] shrink-0">
            <div className="flex gap-[20px]">
              <SmallCard titleKey="exp.powers.c1.title" descKey="exp.powers.c1.desc" />
              <SmallCard titleKey="exp.powers.c2.title" descKey="exp.powers.c2.desc" />
            </div>
            <SmallCard titleKey="exp.powers.c3.title" descKey="exp.powers.c3.desc" />
          </div>
          <BigCard t={t} />
        </div>

        {/* Mobile: stacked */}
        <div className="xl:hidden flex flex-col gap-[12px]">
          <SmallCard titleKey="exp.powers.c1.title" descKey="exp.powers.c1.desc" />
          <SmallCard titleKey="exp.powers.c2.title" descKey="exp.powers.c2.desc" />
          <SmallCard titleKey="exp.powers.c3.title" descKey="exp.powers.c3.desc" />
          <BigCard t={t} />
        </div>
      </div>
    </section>
  );
}

export default Powers;
